import dayjs from 'utils/dayjs';

export default function getProviderSeenDatePairError(
  firstSeenOn?: string | null,
  lastSeenOn?: string | null,
) {
  if (!firstSeenOn || !lastSeenOn) {
    return null;
  }

  const firstSeenDate = dayjs(firstSeenOn);
  const lastSeenDate = dayjs(lastSeenOn);

  if (!firstSeenDate.isValid() || !lastSeenDate.isValid()) {
    return null;
  }

  return lastSeenDate.isBefore(firstSeenDate, 'day')
    ? 'Last seen date must be on or after first seen date.'
    : null;
}
